// src/utils/makeItemKey.ts
export type ItemKeySource = {
    item_code?: string | null;
    sku_code?: string | null;
};

/**
 * item_key のルール：
 * - 先頭の空欄は飛ばす（余計な先頭ハイフンなし）
 * - 中間・末尾の空欄は "-" が残る（例: A01-100-A01-WH-）
 * - 全部空欄なら "" を返す（＝保存対象外）
 */
export function makeItemKey(row: ItemKeySource): string {
    const fields = [
        row.item_code ?? "",
        row.sku_code ?? "",
    ].map((v) => v.trim());

    const firstIdx = fields.findIndex((v) => v !== "");
    if (firstIdx === -1) return ""; // 全空

    let key = fields[firstIdx];
    for (let i = firstIdx + 1; i < fields.length; i++) {
        key += "-" + fields[i];
    }
    return key;
}
